import React, { useState, useEffect } from 'react';
import { useLocale } from '../context/LocaleContext';

const RecoveryActivatedModal = ({ user, onClose }) => {
    const { t } = useLocale();
    const [isVisible, setIsVisible] = useState(false);
    const [dontShowAgain, setDontShowAgain] = useState(false);

    useEffect(() => {
        // Check if user is in recovery mode and hasn't started progress
        if (user.isRecoveryMode && user.recoveryDaysCompleted === 0) {
            const hasSeen = localStorage.getItem(`recovery_seen_${user._id}`);
            if (!hasSeen) {
                setIsVisible(true);
            }
        } else {
            setIsVisible(false);
        }
    }, [user]);

    const handleClose = () => {
        if (dontShowAgain) {
            localStorage.setItem(`recovery_seen_${user._id}`, 'true');
        }
        setIsVisible(false);
        if (onClose) onClose();
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fade-in">
            <div className="bg-slate-900 rounded-2xl p-8 shadow-2xl w-full max-w-md border border-teal-500/30 relative">
                <div className="absolute -top-12 left-1/2 transform -translate-x-1/2 bg-slate-900 rounded-full p-4 border border-teal-500 shadow-lg shadow-teal-500/20">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-teal-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                </div>

                <h2 className="text-3xl font-bold text-white mb-2 text-center mt-6">{t('recoveryModal.title', 'Recovery Mode Active')}</h2>
                <p className="text-teal-400 text-center font-medium mb-6">{t('recoveryModal.subtitle', 'Welcome Back')}</p>

                <div className="space-y-4 text-gray-300 text-sm leading-relaxed mb-8">
                    <p>
                        {t('recoveryModal.body1', "We noticed you've been away for a while. Instead of dropping your level, we've activated Recovery Mode.")}
                    </p>
                    <p>
                        {t('recoveryModal.body2', 'Your level has been preserved. Before jumping back into full training, Forza suggests easing in with a few days of lighter activity such as yoga, walking, or stretching.')}
                    </p>
                    <p className="italic text-gray-400 text-xs text-center border-t border-slate-800 pt-4 mt-4">
                        "{t('recoveryModal.quote', "Rest is not idleness, it's the key to better performance.")}"
                    </p>
                </div>

                <div className="flex items-center mb-4">
                    <input
                        type="checkbox"
                        id="dontShow"
                        checked={dontShowAgain}
                        onChange={(e) => setDontShowAgain(e.target.checked)}
                        className="w-4 h-4 text-teal-600 bg-gray-700 border-gray-600 rounded focus:ring-teal-500 focus:ring-2"
                    />
                    <label htmlFor="dontShow" className="ml-2 text-sm font-medium text-gray-400">{t('recoveryModal.dontShowAgain', "Don't show this again")}</label>
                </div>

                <button
                    onClick={handleClose}
                    className="w-full bg-teal-600 hover:bg-teal-700 text-white font-bold py-3 px-6 rounded-xl transition-all shadow-lg shadow-teal-900/50 hover:shadow-teal-900/80 transform hover:-translate-y-0.5"
                >
                    {t('recoveryModal.cta', 'Start Recovery')}
                </button>
            </div>
        </div>
    );
};

export default RecoveryActivatedModal;
